/**
 * MRK Proofreading Multi-Step Form - JavaScript
 * WITH VISUAL DOCX PREVIEW using docx-preview.js (HTML-based previews)
 * WITH FILE UPLOAD to emmanuela100.sg-host.com/upload.php
 *
 * UPDATED:
 *  1) University guidelines now supports MULTIPLE files.
 *  2) Package markup % ("extra") can be overridden from the Theme Editor
 *     via window.MRK_PACKAGE_EXTRAS (falls back to the variant metafield).
 */

(function ($) {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================

  const PRODUCT_DATA = window.MRK_PRODUCT_DATA || {};
  const MONEY_FORMAT = window.mrkmoneyFormat || '€{{amount_with_comma_separator}}';
  // Per-package markup overrides coming from the Theme Editor.
  // Shape: { "Proofreading": "15", "Editing BASIC": null, ... }
  const PACKAGE_EXTRAS = window.MRK_PACKAGE_EXTRAS || {};

  const MRK_CONFIG = {
    maxFileSize: 50 * 1024 * 1024,
    allowedExtensions: ['.pdf', '.doc', '.docx', '.txt'],
    wordsPerPage: 275,  // Standard words per page estimate
    uploadEndpoint: 'https://emmanuela100.sg-host.com' // <-- FIXED: full path to PHP file
  };

  // ============================================
  // STATE
  // ============================================

  const MRK_STATE = {
    currentStep: 1,
    totalSteps: 4,
    file: null,
    fileUrl: '',                      // stores the uploaded main file URL
    universityGuidelineFiles: [],     // [{ id, file, url, status }] — MULTIPLE files
    pages: [],
    selectedPages: [],
    wordCount: 0,
    service: null || '',
    delivery: window.MRK_PRODUCT_DATA?.variants?.[2]?.options?.[1] || '',
    selectedVariant: null,
    addons: [],
    AddonspreSelect: false,
    totalPrice: 0,
    docxStyles: '' // Store DOCX styles for preview
  };
  console.log(MRK_STATE);

  // Sequence used to give each guideline file a stable unique id
  let mrkGuidelineSeq = 0;

  // ============================================
  // UTILITIES
  // ============================================

  const Utils = {
    countWords(text) {
      if (!text) return 0;

      return text
        .toLowerCase()
        .replace(/[^a-z\s]/g, '')
        .trim()
        .split(/\s+/)
        .filter(w => w.length > 0)
        .length;
    },

    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    },

    truncateFileName(name, maxLength) {
      if (name.length <= maxLength) return name;
      const ext = name.split('.').pop();
      const base = name.substring(0, name.length - ext.length - 1);
      return base.substring(0, maxLength - ext.length - 4) + '...' + '.' + ext;
    },

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    },

    escapeAttr(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    },

    formatMoney(cents) {
      if (typeof cents === 'string') {
        cents = parseFloat(cents.replace('.', ''));
      }

      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

      function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
      }

      let value = '';
      switch (MONEY_FORMAT.match(placeholderRegex)?.[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return MONEY_FORMAT.replace(placeholderRegex, value);
    },

    /**
     * Uploads a file to the server and returns a Promise that resolves
     * with the file URL.
     * Uses MRK_CONFIG.uploadEndpoint — same endpoint for ALL files
     * (main document AND university guidelines).
     */
    uploadFile(file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', file);

        console.log('Uploading to:', MRK_CONFIG.uploadEndpoint, 'file:', file.name, file.size);

        $.ajax({
          url: MRK_CONFIG.uploadEndpoint,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          xhrFields: {
            withCredentials: false
          },
          success(response) {
            if (response && response.success && response.url) {
              resolve(response);
            } else {
              reject(new Error(response?.error || 'Upload failed'));
            }
          },
          error(xhr, status, err) {
            let msg = 'Upload failed';
            try {
              const r = JSON.parse(xhr.responseText);
              if (r && r.error) msg = r.error;
            } catch (e) { /* ignore */ }
            reject(new Error(msg + ' (' + (xhr.status || status) + ')'));
          }
        });
      });
    }
  };

  // ============================================
  // SHOPIFY HELPERS
  // ============================================

  function findVariant(service, delivery) {
    if (!PRODUCT_DATA.variants) return null;
    return PRODUCT_DATA.variants.find(v => v.option1 === service && v.option2 === delivery);
  }

  /**
   * Resolve the markup percentage for a package.
   * Priority: Theme Editor override (window.MRK_PACKAGE_EXTRAS) -> variant metafield "extra" -> 0
   */
  function getPackageExtra(service) {
    const override = PACKAGE_EXTRAS[service];
    if (override !== undefined && override !== null && override !== '' && !isNaN(parseFloat(override))) {
      return parseFloat(override);
    }
    return Number(MRK_STATE.selectedVariant?.extra) || 0;
  }

  // ============================================
  // DEPENDENCY LOADING
  // ============================================

  async function loadScript(src, check) {
    if (check && check()) return true;

    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.head.appendChild(script);
    });
  }

  async function loadDependencies() {
    console.log('Loading dependencies...');

    // PDF.js
    if (typeof pdfjsLib === 'undefined') {
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js');
      if (typeof pdfjsLib !== 'undefined') {
        pdfjsLib.GlobalWorkerOptions.workerSrc =
          'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      }
    }

    // JSZip (required for docx-preview)
    if (typeof JSZip === 'undefined') {
      await loadScript('https://unpkg.com/jszip/dist/jszip.min.js');
    }

    // docx-preview for DOCX visual rendering
    if (typeof docx === 'undefined') {
      await loadScript('https://unpkg.com/docx-preview/dist/docx-preview.min.js');
    }

    console.log('Dependencies loaded:', {
      pdfjs: typeof pdfjsLib !== 'undefined',
      JSZip: typeof JSZip !== 'undefined',
      docxPreview: typeof docx !== 'undefined'
    });
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function init() {
    MRK_STATE.selectedVariant = findVariant(MRK_STATE.service, MRK_STATE.delivery);

    // Create hidden container for DOCX rendering
    if (!$('#mrk-docx-render-container').length) {
      $('body').append(`
        <div id="mrk-docx-render-container" style="
          position: absolute;
          left: -9999px;
          top: 0;
          width: 800px;
          background: white;
          visibility: hidden;
        "></div>
      `);
    }

    // Create zoom modal if not exists
    if (!$('#mrk-zoom-modal').length) {
      $('body').append(`
        <div id="mrk-zoom-modal" class="mrk-zoom-modal">
          <div class="mrk-zoom-modal-content">
            <button class="mrk-zoom-close">&times;</button>
            <div class="mrk-zoom-body"></div>
          </div>
        </div>
      `);
    }

    loadDependencies().then(() => {
      bindEvents();
      updateAllPrices();
      updateSummary();
      console.log('Form ready');
    });
  }

  // ============================================
  // EVENT BINDING
  // ============================================

  function bindEvents() {
    const $fileInput = $('#mrk-file-input');

    $('#mrk-upload-btn').on('click', () => $fileInput.trigger('click'));
    $fileInput.on('change', (e) => {
      if (e.target.files.length > 0) handleFile(e.target.files[0]);
    });

    $('#mrk-upload-zone')
      .on('dragover dragenter', function (e) {
        e.preventDefault();
        $(this).addClass('mrk-drag-over');
      })
      .on('dragleave dragend drop', function (e) {
        e.preventDefault();
        $(this).removeClass('mrk-drag-over');
      })
      .on('drop', function (e) {
        const files = e.originalEvent.dataTransfer.files;
        if (files.length > 0) handleFile(files[0]);
      });

    $('#mrk-file-remove').on('click', (e) => {
      e.stopPropagation();
      removeFile();
    });

    // ===== university guidelines (MULTIPLE files) =====
    const $universityfileInput = $('#mrk-university-guidelines-input');
    $('#mrk-university-guidelines-btn').on('click', () => $universityfileInput.trigger('click'));

    $universityfileInput.on('change', function () {
      if (this.files && this.files.length > 0) {
        handleUniversityGuidelineFiles(this.files);
      }
      // Reset so re-selecting the same file still fires "change"
      this.value = '';
    });

    $('#mrk-university-guidelines-zone')
      .on('dragover dragenter', function (e) {
        e.preventDefault();
        $(this).addClass('mrk-drag-over');
      })
      .on('dragleave dragend drop', function (e) {
        e.preventDefault();
        $(this).removeClass('mrk-drag-over');
      })
      .on('drop', function (e) {
        const files = e.originalEvent.dataTransfer.files;
        if (files.length > 0) handleUniversityGuidelineFiles(files);
      });

    // Remove a single guideline file (delegated — rows are added dynamically)
    $(document).on('click', '.mrk-guideline-remove', function (e) {
      e.preventDefault();
      e.stopPropagation();
      removeUniversityGuidelineFile($(this).data('id'));
    });

    $('#mrk-btn-next').on('click', nextStep);
    $('#mrk-btn-back').on('click', prevStep);

    $('#mrk-select-all').on('click', selectAllPages);
    $('#mrk-deselect-all').on('click', deselectAllPages);
    $('#mrk-notice-close').on('click', () => $('#mrk-pages-notice').slideUp());

    $(document).on('change', 'input[name="mrk-variant"]', function () {
      MRK_STATE.service = $(this).val();
      $('.mrk-variant-option').removeClass('mrk-variant-selected');
      $(this).closest('.mrk-variant-option').addClass('mrk-variant-selected');
      MRK_STATE.selectedVariant = findVariant(MRK_STATE.service, MRK_STATE.delivery);
      updateAllPrices();
      updateSummary();
      updateAddonspreSelect();
      updateDeliveryVisiblity();
    });

    $(document).on('change', 'input[name="mrk-delivery"]', function () {
      MRK_STATE.delivery = $(this).val();
      $('.mrk-delivery-option').removeClass('mrk-delivery-selected');
      $(this).closest('.mrk-delivery-option').addClass('mrk-delivery-selected');
      MRK_STATE.selectedVariant = findVariant(MRK_STATE.service, MRK_STATE.delivery);
      updateDeliveryDate();
      updateAllPrices();
      updateSummary();
    });

    $(document).on('change', '.mrk-addon-checkbox', function () {
      const $item = $(this).closest('.mrk-addon-item');
      const name = $(this).val();
      const variantId = $(this).attr('variant');
      const price = parseInt($(this).data('price')) || 0;

      if ($(this).is(':checked')) {
        $item.addClass('mrk-addon-selected');
        MRK_STATE.addons.push({ name, variantId, price, preselect: $(this).hasClass('mrk-price-included') });
      } else {
        $item.removeClass('mrk-addon-selected');
        MRK_STATE.addons = MRK_STATE.addons.filter(a => a.name !== name);
      }
      updateSummary();
    });

    $(document).on('click', '.mrk-info-btn', function (e) {
      e.preventDefault();
      e.stopPropagation();
      showInfoModal();
    });

    $(document).on('click', '#mrk-info-modal .mrk-modal-close', hideInfoModal);
    $(document).on('click', '#mrk-info-modal', function (e) {
      if (e.target === this) hideInfoModal();
    });

    // Page item click (but not on zoom button)
    $(document).on('click', '.mrk-page-item', function (e) {
      if (!$(e.target).closest('.mrk-zoom-btn').length) {
        togglePageSelection($(this));
      }
    });

    // Zoom button click
    $(document).on('click', '.mrk-zoom-btn', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const pageNum = parseInt($(this).data('page'));
      showZoomModal(pageNum);
    });

    // Zoom modal close
    $(document).on('click', '.mrk-zoom-close', hideZoomModal);
    $(document).on('click', '#mrk-zoom-modal', function (e) {
      if (e.target === this) hideZoomModal();
    });
  }

  // ============================================
  // FILE HANDLING — MAIN DOCUMENT
  // ============================================

  function handleFile(file) {
    const ext = '.' + file.name.split('.').pop().toLowerCase();

    if (!MRK_CONFIG.allowedExtensions.includes(ext)) {
      alert('Please upload a PDF, DOC, DOCX, or TXT file.');
      return;
    }

    if (file.size > MRK_CONFIG.maxFileSize) {
      alert('File size exceeds 50MB limit.');
      return;
    }

    MRK_STATE.file = file;
    MRK_STATE.fileUrl = ''; // reset until upload completes

    $('#mrk-upload-content').hide();
    $('#mrk-uploaded-file').show();
    $('#mrk-upload-zone').addClass('mrk-has-file');
    $('#mrk-file-name').text(Utils.truncateFileName(file.name, 30));
    $('#mrk-file-size').text(Utils.formatFileSize(file.size));

    // Disable next button while uploading
    $('#mrk-btn-next').prop('disabled', true);

    // Show small "uploading" status near the file
    if (!$('#mrk-file-upload-status').length) {
      $('#mrk-uploaded-file .mrk-file-details').append(
        '<span id="mrk-file-upload-status" class="mrk-file-size" style="color:#518756;">Uploading…</span>'
      );
    } else {
      $('#mrk-file-upload-status').text('Uploading…').css('color', '#518756').show();
    }

    // Upload main document to server
    Utils.uploadFile(file)
      .then((response) => {
        MRK_STATE.fileUrl = response.url;
        console.log('Main file uploaded:', response);
        $('#mrk-file-upload-status')
          .text(response.cached ? 'Uploaded (cached) ✓' : 'Uploaded ✓')
          .css('color', '#518756');
        updateNextButton();
        updateInputs();
      })
      .catch((err) => {
        console.error('Main file upload failed:', err);
        $('#mrk-file-upload-status')
          .text('Upload failed — ' + err.message)
          .css('color', '#EF4444');
        alert('Failed to upload your file: ' + err.message + '\nPlease try again or use a different file.');
        updateNextButton();
      });

    updateNextButton();
  }

  function removeFile() {
    MRK_STATE.file = null;
    MRK_STATE.fileUrl = '';
    MRK_STATE.pages = [];
    MRK_STATE.selectedPages = [];
    MRK_STATE.wordCount = 0;
    MRK_STATE.docxStyles = '';

    $('#mrk-upload-content').show();
    $('#mrk-uploaded-file').hide();
    $('#mrk-upload-zone').removeClass('mrk-has-file');
    $('#mrk-file-input').val('');
    $('#mrk-file-upload-status').remove();

    updateNextButton();
    updateSummary();
  }

  // ============================================
  // FILE HANDLING — UNIVERSITY GUIDELINES (MULTIPLE)
  // Uses the SAME uploadFile() and SAME endpoint
  // ============================================

  function handleUniversityGuidelineFiles(fileList) {
    Array.from(fileList).forEach(file => addOneGuidelineFile(file));
    updateNextButton();
  }

  function addOneGuidelineFile(file) {
    const ext = '.' + file.name.split('.').pop().toLowerCase();

    if (!MRK_CONFIG.allowedExtensions.includes(ext)) {
      alert('Please upload a PDF, DOC, DOCX, or TXT file.');
      return;
    }

    if (file.size > MRK_CONFIG.maxFileSize) {
      alert('"' + file.name + '" exceeds the 50MB limit.');
      return;
    }

    const id = 'g' + (++mrkGuidelineSeq);
    const entry = { id, file, url: '', status: 'uploading' };
    MRK_STATE.universityGuidelineFiles.push(entry);

    renderGuidelineFileRow(entry);
    $('#mrk-university-guidelines-zone').addClass('mrk-has-file');

    Utils.uploadFile(file)
      .then((response) => {
        entry.url = response.url;
        entry.status = 'done';
        console.log('Guideline file uploaded:', response);
        $(`.mrk-guideline-file[data-id="${id}"] .mrk-file-upload-status`)
          .text(response.cached ? 'Uploaded (cached) ✓' : 'Uploaded ✓')
          .css('color', '#518756');
        updateInputs();
      })
      .catch((err) => {
        entry.status = 'error';
        console.error('Guideline upload failed:', err);
        $(`.mrk-guideline-file[data-id="${id}"] .mrk-file-upload-status`)
          .text('Upload failed — ' + err.message)
          .css('color', '#EF4444');
      });
  }

  function renderGuidelineFileRow(entry) {
    const html = `
      <div class="mrk-uploaded-file mrk-guideline-file" data-id="${entry.id}">
        <div class="mrk-file-info">
          <div class="mrk-file-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14 2V8H20" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="mrk-file-details">
            <span class="mrk-file-name">${Utils.escapeHtml(Utils.truncateFileName(entry.file.name, 30))}</span>
            <span class="mrk-file-size">${Utils.formatFileSize(entry.file.size)}</span>
            <span class="mrk-file-upload-status mrk-file-size" style="color:#518756;">Uploading…</span>
          </div>
        </div>
        <button type="button" class="mrk-file-remove mrk-guideline-remove" data-id="${entry.id}" title="Remove">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 5H4.16667H17.5" stroke="#EF4444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.66667 5V3.33333C6.66667 2.89131 6.84226 2.46738 7.15482 2.15482C7.46738 1.84226 7.89131 1.66667 8.33333 1.66667H11.6667C12.1087 1.66667 12.5326 1.84226 12.8452 2.15482C13.1577 2.46738 13.3333 2.89131 13.3333 3.33333V5M15.8333 5V16.6667C15.8333 17.1087 15.6577 17.5326 15.3452 17.8452C15.0326 18.1577 14.6087 18.3333 14.1667 18.3333H5.83333C5.39131 18.3333 4.96738 18.1577 4.65482 17.8452C4.34226 17.5326 4.16667 17.1087 4.16667 16.6667V5H15.8333Z" stroke="#EF4444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    `;
    $('#mrk-university-guidelines-list').append(html);
  }

  function removeUniversityGuidelineFile(id) {
    MRK_STATE.universityGuidelineFiles =
      MRK_STATE.universityGuidelineFiles.filter(g => g.id !== id);
    $(`.mrk-guideline-file[data-id="${id}"]`).remove();

    if (MRK_STATE.universityGuidelineFiles.length === 0) {
      $('#mrk-university-guidelines-zone').removeClass('mrk-has-file');
    }

    updateInputs();
    updateNextButton();
  }

  // ============================================
  // DOCUMENT PROCESSING
  // ============================================

  async function processDocument() {
    const file = MRK_STATE.file;
    if (!file) return;

    $('#mrk-pages-loading').show();
    $('#mrk-pages-grid .mrk-page-item').remove();

    const ext = '.' + file.name.split('.').pop().toLowerCase();

    try {
      if (ext === '.pdf') {
        await processPDF(file);
      } else if (ext === '.docx') {
        await processDOCX(file);
      } else {
        await processTXT(file);
      }
    } catch (error) {
      console.error('Processing error:', error);
      createFallbackPages();
    }

    $('#mrk-pages-loading').hide();
    updatePageCount();
    updateSummary();
  }

  // ============================================
  // PDF PROCESSING (with visual preview)
  // ============================================

  async function processPDF(file) {
    if (typeof pdfjsLib === 'undefined') {
      createFallbackPages();
      return;
    }

    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument(arrayBuffer).promise;
    const numPages = pdf.numPages;

    MRK_STATE.pages = [];
    MRK_STATE.selectedPages = [];

    for (let i = 1; i <= numPages; i++) {
      const page = await pdf.getPage(i);
      const textContent = await page.getTextContent();
      const text = textContent.items.map(item => item.str).join(' ');
      // Render to canvas
      const canvas = document.createElement('canvas');
      const viewport = page.getViewport({ scale: 1 });
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({
        canvasContext: canvas.getContext('2d'),
        viewport: viewport
      }).promise;

      const pageData = {
        number: i,
        text: text,
        wordCount: Utils.countWords(text),
        preview: canvas.toDataURL('image/jpeg', 1),
        previewHtml: null,
        selected: true,
        type: 'pdf'
      };

      MRK_STATE.pages.push(pageData);
      MRK_STATE.selectedPages.push(i);
      renderPageItem(pageData);
    }

    calculateTotalWordCount();
  }

  // ============================================
  // DOCX PROCESSING (HTML preview + robust pagination)
  // ============================================

  async function processDOCX(file) {
    if (typeof docx === 'undefined') {
      console.warn('docx-preview not loaded, falling back to text preview');
      await processDOCXFallback(file);
      return;
    }

    const arrayBuffer = await file.arrayBuffer();
    const $container = $('#mrk-docx-render-container');
    $container.empty();

    try {
      await docx.renderAsync(arrayBuffer, $container[0], null, {
        className: 'docx',
        inWrapper: true,
        ignoreWidth: false,
        ignoreHeight: false,
        ignoreFonts: false,
        breakPages: true,
        ignoreLastRenderedPageBreak: false,
        experimental: false,
        trimXmlDeclaration: true,
        useBase64URL: true,
        renderHeaders: true,
        renderFooters: true,
        renderFootnotes: true,
        renderEndnotes: true,
        renderComments: false,   // ignore comments when rendering
        debug: false
      });

      await new Promise(resolve => setTimeout(resolve, 300));

      // Capture styles for the previews
      let stylesHtml = '';
      $container.find('style').each(function () { stylesHtml += this.outerHTML; });
      MRK_STATE.docxStyles = stylesHtml;

      const $wrapper = $container.find('.docx-wrapper');
      const $pages = $container.find('section.docx');

      console.log('Found sections:', $pages.length);

      MRK_STATE.pages = [];
      MRK_STATE.selectedPages = [];

      // A single docx-preview "section" should never hold many pages of text.
      // If it does, Word didn't embed page-break markers in that part of the
      // document, so we sub-split that section by word count.
      const OVERSIZE = MRK_CONFIG.wordsPerPage * 3;
      let pageNumber = 0;

      if ($pages.length > 0) {
        $pages.each(function () {
          const $page = $(this);
          const pageHtml = $page[0].outerHTML;
          const text = $page.text();
          const words = Utils.countWords(text);

          if (words === 0) return; // skip blank sections (e.g. empty title-page back)

          if (words <= OVERSIZE) {
            // Trustworthy real page -> keep the visual HTML preview
            pageNumber++;
            const pageData = {
              number: pageNumber,
              text: text.substring(0, 5000),
              wordCount: words,
              preview: null,
              previewHtml: pageHtml,
              selected: true,
              type: 'docx'
            };
            MRK_STATE.pages.push(pageData);
            MRK_STATE.selectedPages.push(pageNumber);
            renderPageItem(pageData);
          } else {
            // Oversized section -> split into page-sized chunks (text previews)
            const wordArr = text.split(/\s+/).filter(w => w.length > 0);
            const sub = Math.ceil(wordArr.length / MRK_CONFIG.wordsPerPage);
            for (let i = 0; i < sub; i++) {
              const slice = wordArr.slice(i * MRK_CONFIG.wordsPerPage, (i + 1) * MRK_CONFIG.wordsPerPage);
              pageNumber++;
              const pageData = {
                number: pageNumber,
                text: slice.join(' '),
                wordCount: slice.length,
                preview: null,
                previewHtml: null,
                selected: true,
                type: 'docx'
              };
              MRK_STATE.pages.push(pageData);
              MRK_STATE.selectedPages.push(pageNumber);
              renderPageItem(pageData);
            }
          }
        });

        // If, after skipping blanks, nothing remained, fall back to full-text pagination
        if (MRK_STATE.pages.length === 0) {
          const $content = $wrapper.length ? $wrapper : $container;
          paginateFullText($content.text(), $content.html());
        }
      } else {
        const $content = $wrapper.length ? $wrapper : $container;
        paginateFullText($content.text(), $content.html());
      }

      $container.empty();
      calculateTotalWordCount();

    } catch (error) {
      console.error('DOCX rendering error:', error);
      $container.empty();
      await processDOCXFallback(file);
    }
  }

  // Paginate raw rendered text by word count (used when docx-preview gives no usable sections)
  function paginateFullText(fullText, fullHtml) {
    const words = (fullText || '').split(/\s+/).filter(w => w.length > 0);
    const totalWords = Utils.countWords(fullText);
    const numPages = Math.max(1, Math.ceil(totalWords / MRK_CONFIG.wordsPerPage));

    for (let i = 0; i < numPages; i++) {
      const slice = words.slice(i * MRK_CONFIG.wordsPerPage, (i + 1) * MRK_CONFIG.wordsPerPage);
      const pageData = {
        number: i + 1,
        text: slice.join(' '),
        wordCount: slice.length,
        preview: null,
        previewHtml: i === 0 ? fullHtml : null,
        selected: true,
        type: 'docx'
      };
      MRK_STATE.pages.push(pageData);
      MRK_STATE.selectedPages.push(i + 1);
      renderPageItem(pageData);
    }
  }

  // ============================================
  // TXT PROCESSING (instant)
  // ============================================

  async function processTXT(file) {
    const text = await file.text();
    const totalWords = Utils.countWords(text);

    const words = text.split(/\s+/).filter(w => w.length > 0);
    const numPages = Math.max(1, Math.ceil(totalWords / MRK_CONFIG.wordsPerPage));
    const wordsPerPage = Math.ceil(words.length / numPages);

    MRK_STATE.pages = [];
    MRK_STATE.selectedPages = [];

    for (let i = 0; i < numPages; i++) {
      const startIdx = i * wordsPerPage;
      const endIdx = Math.min((i + 1) * wordsPerPage, words.length);
      const pageWords = words.slice(startIdx, endIdx);
      const pageText = pageWords.join(' ');

      const pageData = {
        number: i + 1,
        text: pageText,
        wordCount: pageWords.length,
        preview: null,
        previewHtml: null,
        selected: true,
        type: 'txt'
      };

      MRK_STATE.pages.push(pageData);
      MRK_STATE.selectedPages.push(i + 1);
      renderPageItem(pageData);
    }

    calculateTotalWordCount();
  }

  // ============================================
  // FALLBACK
  // ============================================

  function createFallbackPages() {
    MRK_STATE.pages = [{
      number: 1,
      text: 'Unable to process document',
      wordCount: 2500,
      preview: null,
      previewHtml: null,
      selected: true,
      type: 'fallback'
    }];
    MRK_STATE.selectedPages = [1];
    renderPageItem(MRK_STATE.pages[0]);
    calculateTotalWordCount();
  }

  // ============================================
  // PAGE RENDERING
  // ============================================

  function renderPageItem(pageData) {
    const selectedClass = pageData.selected ? 'mrk-page-selected' : '';
    const uniqueId = `mrk-page-preview-${pageData.number}-${Date.now()}`;

    let previewContent;

    if (pageData.preview) {
      previewContent = `
        <img src="${pageData.preview}" alt="Page ${pageData.number}">
        <div class="mrk-zoom-btn mrk-doc-previewer" data-page="${pageData.number}">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
            <path d="M11 8v6"></path>
            <path d="M8 11h6"></path>
          </svg>
        </div>
      `;
    } else if (pageData.previewHtml) {
      previewContent = `
        <div class="mrk-page-preview-html" id="${uniqueId}">
          <div class="mrk-page-type-badge">DOCX</div>
          <div class="mrk-zoom-btn mrk-doc-previewer" data-page="${pageData.number}">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
              <path d="M11 8v6"></path>
              <path d="M8 11h6"></path>
            </svg>
          </div>
          <div class="mrk-html-content-wrapper">
            <div class="mrk-html-content">${MRK_STATE.docxStyles}${pageData.previewHtml}</div>
          </div>
        </div>
      `;
    } else {
      const previewText = pageData.text.substring(0, 2500);
      previewContent = `
        <div class="mrk-page-preview-text">
          <div class="mrk-page-type-badge">${pageData.type?.toUpperCase() || 'DOC'}</div>
          <div class="mrk-zoom-btn text-type" data-page="${pageData.number}">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
              <path d="M11 8v6"></path>
              <path d="M8 11h6"></path>
            </svg>
          </div>
          ${Utils.escapeHtml(previewText)}${previewText.length >= 2500 ? '...' : ''}
        </div>
      `;
    }

    const html = `
      <div class="mrk-page-item ${selectedClass}" data-page="${pageData.number}">
        <div class="mrk-page-preview">${previewContent}</div>
        <div class="mrk-page-footer">
          <span class="mrk-page-number">Page ${pageData.number}</span>
          <span class="mrk-page-words">${pageData.wordCount.toLocaleString()} words</span>
          <div class="mrk-page-checkbox">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    `;

    $('#mrk-pages-grid').append(html);
  }

  // ============================================
  // ZOOM MODAL
  // ============================================

  function showZoomModal(pageNum) {
    const pageData = MRK_STATE.pages.find(p => p.number === pageNum);
    if (!pageData) return;

    const $modal = $('#mrk-zoom-modal');
    const $body = $modal.find('.mrk-zoom-body');

    $body.empty();

    if (pageData.preview) {
      $body.html(`<img src="${pageData.preview}" alt="Page ${pageNum}" style="max-width: 100%; height: auto;">`);
    } else if (pageData.previewHtml) {
      $body.html(`
        <div class="mrk-zoom-docx-content">
          ${MRK_STATE.docxStyles}
          ${pageData.previewHtml}
        </div>
      `);
    } else {
      $body.html(`<div class="mrk-zoom-text-content">${Utils.escapeHtml(pageData.text)}</div>`);
    }

    $modal.addClass('mrk-zoom-modal-visible');
    $('body').css('overflow', 'hidden');
  }

  function hideZoomModal() {
    $('#mrk-zoom-modal').removeClass('mrk-zoom-modal-visible');
    $('body').css('overflow', '');
  }

  // ============================================
  // PAGE SELECTION
  // ============================================

  function togglePageSelection($item) {
    const pageNum = parseInt($item.data('page'));
    const pageData = MRK_STATE.pages.find(p => p.number === pageNum);

    if ($item.hasClass('mrk-page-selected')) {
      $item.removeClass('mrk-page-selected');
      pageData.selected = false;
      MRK_STATE.selectedPages = MRK_STATE.selectedPages.filter(p => p !== pageNum);
    } else {
      $item.addClass('mrk-page-selected');
      pageData.selected = true;
      MRK_STATE.selectedPages.push(pageNum);
    }

    calculateTotalWordCount();
    updatePageCount();
    updateNextButton();
    updateSummary();
  }

  function selectAllPages() {
    $('.mrk-page-item').addClass('mrk-page-selected');
    MRK_STATE.pages.forEach(p => p.selected = true);
    MRK_STATE.selectedPages = MRK_STATE.pages.map(p => p.number);
    calculateTotalWordCount();
    updatePageCount();
    updateSummary();
  }

  function deselectAllPages() {
    $('.mrk-page-item').removeClass('mrk-page-selected');
    MRK_STATE.pages.forEach(p => p.selected = false);
    MRK_STATE.selectedPages = [];
    calculateTotalWordCount();
    updatePageCount();
    updateNextButton();
    updateSummary();
  }

  function updatePageCount() {
    $('#mrk-selected-count').text(MRK_STATE.selectedPages.length);
    $('#mrk-total-pages').text(MRK_STATE.pages.length);
  }

  // ============================================
  // NAVIGATION
  // ============================================

  function nextStep() {
    if($('.mrk-form-step-active #terms_and_conditions').length && !$('.mrk-form-step-active #terms_and_conditions:checked').length){
      $('html, body').animate({ scrollTop: 0 }, 0);
      alert('Bitte bestätige, dass du die Hinweise gelesen hast.');
      return;
    }

    // Don't advance while any guideline file is still uploading
    if (MRK_STATE.universityGuidelineFiles.some(g => g.status === 'uploading')) {
      alert('Please wait until your guideline files have finished uploading.');
      return;
    }

    if (MRK_STATE.currentStep === 1 && MRK_STATE.file) {
      // Block step navigation until the file has been uploaded
      if (!MRK_STATE.fileUrl) {
        alert('Please wait until the file has finished uploading.');
        return;
      }
      $('.mrk-loader-wrapper').css('display', 'flex');
      processDocument().then(() => { $('.mrk-loader-wrapper').hide(); goToStep(2) });
    } else if (MRK_STATE.currentStep < MRK_STATE.totalSteps) {
      goToStep(MRK_STATE.currentStep + 1);
    }
  }

  function prevStep() {
    if (MRK_STATE.currentStep > 1) {
      goToStep(MRK_STATE.currentStep - 1);
    }
  }

  function goToStep(step) {

    if(step == 3){
      $('[name="mrk-variant"]:checked').trigger('change');
    }
    if(step == 4 && !$('[name="mrk-variant"]:checked').length){
      $('html, body').animate({ scrollTop: 0 }, 0);
      alert(`Please Select ${window.MRK_PRODUCT_DATA.options[0]}`);
      return;
    }

    $('.mrk-step').each(function (index) {
      const stepNum = index + 1;
      $(this).removeClass('mrk-step-active mrk-step-completed');
      if (stepNum < step) $(this).addClass('mrk-step-completed');
      else if (stepNum === step) $(this).addClass('mrk-step-active');
    });

    $('.mrk-step-line').each(function (index) {
      $(this).toggleClass('mrk-line-active', index < step - 1);
    });

    $('.mrk-form-step').removeClass('mrk-form-step-active');
    $(`.mrk-form-step[data-step="${step}"]`).addClass('mrk-form-step-active');

    $('#mrk-btn-back').toggle(step > 1);
    $('#mrk-btn-next').toggle(step < MRK_STATE.totalSteps);
    $('.mrk-product-form-wrapper').toggle(step === MRK_STATE.totalSteps);

    MRK_STATE.currentStep = step;
    updateNextButton();
    updateAllPrices();
    $('html, body').animate({ scrollTop: 0 }, 0);

  }

  function updateNextButton() {
    const $btn = $('#mrk-btn-next');

    switch (MRK_STATE.currentStep) {
      case 1:
        // Disabled until file is selected AND uploaded
        $btn.prop('disabled', !MRK_STATE.file || !MRK_STATE.fileUrl);
        break;
      case 2:
        $btn.prop('disabled', MRK_STATE.selectedPages.length === 0);
        break;
      default:
        $btn.prop('disabled', false);
    }
  }

  // ============================================
  // PRICING
  // ============================================
  function updateAddonspreSelect() {
    if ($('[name="mrk-variant"]:checked').attr('addons') == 'true') {
      $('.mrk-addon-item:not(:last-child) input').prop('checked', true).trigger('change');
    } else if ($('.mrk-addon-item:not(:last-child) input').length) {
      $('.mrk-addon-item:not(:last-child) input').prop('checked', false).trigger('change');
    }
  }

  function updateDeliveryVisiblity() {
    if ($('[name="mrk-variant"]:checked').attr('no-delivery') == 'true') {
      $('.mrk-delivery-options-wrapper').hide();
      $('.mrk-summary-price').hide();
      $('[name="mrk-delivery"]:eq(0)').prop('checked', true).trigger('change')
    } else{
      $('.mrk-delivery-options-wrapper').show();
      $('.mrk-summary-price').show();
    }
  }

  function calculateTotalWordCount() {
    console.log(MRK_STATE.pages);
    MRK_STATE.wordCount = MRK_STATE.pages
      .filter(p => p.selected)
      .reduce((sum, p) => sum + p.wordCount, 0);
  }

  function updateAllPrices() {
    $('.mrk-variant-option').each(function () {
      const serviceName = $(this).data('variant');
      const variant = findVariant(serviceName, MRK_STATE.delivery);

      if (variant) {
        const pages = Math.ceil(MRK_STATE.wordCount / 180);
        const total = (variant.perPagePrice) * 100;
        $(this).find('.mrk-price-amount').text(
          Utils.formatMoney(total)
        );
      }
    });
  }

  function updateSummary() {
    calculateTotalWordCount();

    let variantPrice = MRK_STATE.selectedVariant?.perPagePrice * 100 || 0;
    // Markup % — Theme Editor override first, then the variant metafield.
    const extraPct = getPackageExtra(MRK_STATE.service);
    variantPrice = variantPrice + (variantPrice * (extraPct / 100));
    var addonsPrice = MRK_STATE.addons.reduce((sum, a) => sum + (a.price || 0), 0);
    var preselectAddonsPrice = 0;
    $('.mrk-addon-checkbox:not(.mrk-price-included):checked').each(function () {
      preselectAddonsPrice = preselectAddonsPrice + Number($(this).data('price'))
    })
    if ($('[name="mrk-variant"]:checked').attr('addons') == 'true') {
      addonsPrice = addonsPrice - preselectAddonsPrice;
    }
    $('.mrk-addon-checkbox:not(.mrk-price-included)').each(function () {
      if ($('[name="mrk-variant"]:checked').attr('addons') == 'true') {
        $(this).addClass('mrk-addon-disabled');
      } else {
        $(this).removeClass('mrk-addon-disabled');
      }
    })
    MRK_STATE.totalPrice = (variantPrice * Math.ceil(MRK_STATE.wordCount / 180)) + addonsPrice;
    if (MRK_STATE.delivery && MRK_STATE.service) {
      $('#mrk-summary-price').text(Utils.formatMoney(MRK_STATE.totalPrice));
    }
    else {
      $('#mrk-summary-price').text('--');
    }
    $('#mrk-summary-pages').text(MRK_STATE.selectedPages.length || '-');
    $('#mrk-stander-pages').text(Math.ceil(MRK_STATE.wordCount / 180) || '-');
    $('#mrk-summary-words').text(MRK_STATE.wordCount ? MRK_STATE.wordCount.toLocaleString() : '-');
    $('#mrk-summary-filename').text(MRK_STATE.file ? Utils.truncateFileName(MRK_STATE.file.name, 20) : '-');
    $('#mrk-summary-variant').text(MRK_STATE.service);

    updateDeliveryDate();
    updateAddonsTags();
    updateInputs();
  }

  function updateDeliveryDate() {
    const deliveryMatch = MRK_STATE.delivery.match(/(\d+)/);
    const days = deliveryMatch ? parseInt(deliveryMatch[1]) : 7;

    const date = new Date();
    date.setDate(date.getDate() + days);
    $('#mrk-summary-delivery-date').text(
      date.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    );
  }

  function updateAddonsTags() {
    const $container = $('#mrk-summary-addons');
    if (MRK_STATE.addons.length === 0) {
      $container.html('<span class="mrk-summary-value">-</span>');
    } else {
      const tags = MRK_STATE.addons.map(a => `<span class="mrk-tag">${a.name}</span>`).join('');
      $container.html(`<div class="mrk-summary-tags">${tags}</div>`);
    }
  }

  // ============================================
  // MODAL
  // ============================================

  function showInfoModal() {
    const $modal = $('#mrk-info-modal');
    if (!$modal.length) return;

    const services = ['Proofreading', 'Editing BASIC', 'Editing PLUS'];
    services.forEach(service => {
      const v = findVariant(service, '7 Days');
      $modal.find(`[data-mrk-price="${service}"]`).text(v ? Utils.formatMoney(v.price) : '-');
    });

    $modal.show();
    setTimeout(() => $modal.addClass('mrk-modal-visible'), 10);
  }

  function hideInfoModal() {
    const $modal = $('#mrk-info-modal');
    if (!$modal.length) return;

    $modal.removeClass('mrk-modal-visible');
    setTimeout(() => $modal.hide(), 300);
  }

  // ============================================
  // FORM INPUTS — main file + ALL guideline files get sent to Shopify
  // ============================================

  function updateInputs() {
    const $inputs = $('.mrk-inputs').empty();
    let idx = 0;

    if (MRK_STATE.selectedVariant) {
      $('[name="id"]').val(MRK_STATE.selectedVariant.id);
      $inputs.append(`<input type="hidden" name="quantity" value="${Math.ceil((MRK_STATE.wordCount / 180))}">`);

      const props = {
        '_file_name': MRK_STATE.file?.name || 'No file',
        'File URL': MRK_STATE.fileUrl || '',                               // uploaded main file URL
        'Ausgewählte Seiten': MRK_STATE.selectedPages.join(', '),
        'Wörter': MRK_STATE.wordCount,
        'Normseiten': MRK_STATE.pages.length,
        'Variante': MRK_STATE.service,
        'Zeit': MRK_STATE.delivery
      };

      Object.entries(props).forEach(([key, value]) => {
        // Skip empty optional main-file URL so it doesn't clutter the order
        if (value === '' && key === 'File URL') return;
        $inputs.append(`<input type="hidden" name="properties[${key}]" value="${Utils.escapeAttr(value)}">`);
      });

      // Multiple university guideline URLs → one line item property each
      const guidelineUrls = MRK_STATE.universityGuidelineFiles
        .filter(g => g.url)
        .map(g => g.url);

      guidelineUrls.forEach((url, i) => {
        const label = guidelineUrls.length > 1 ? `Guidelines URL ${i + 1}` : 'Guidelines URL';
        $inputs.append(`<input type="hidden" name="properties[${label}]" value="${Utils.escapeAttr(url)}">`);
      });

      idx++;
    }
    MRK_STATE.addons.forEach(addon => {
      if (addon.variantId) {
        if ($('[name="mrk-variant"]:checked').attr('addons') == 'true' && addon.preselect == false) {
          return;
        }
        $inputs.append(`
          <input type="hidden" name="items[${idx}][id]" value="${addon.variantId}">
          <input type="hidden" name="items[${idx}][parent_id]" value="${MRK_STATE.selectedVariant.id}">
        `);
        idx++;
      }
    });
  }

  // ============================================
  // INIT
  // ============================================

  $(document).ready(init);

})(jQuery);
  